import React from 'react'
import Link from "gatsby-link"
import styled, { css, injectGlobal } from 'styled-components'
import { VelocityTransitionGroup } from 'velocity-react'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import rgba from 'polished'

import close from '../../assets/icons/close.svg'

import { bgIcon, hoverState } from '../../styles/global'
import { media, width } from '../../styles/utils'
import { paragraph } from '../../styles/type';

class Share extends React.Component {

	state = {
        active: false
	}
		
	componentDidMount() {
    }

    lockScroll = () => {
        const shareModal = document.querySelector('#share-modal');
        const mobileStickyHeader = document.querySelector('#mobile-sticky-header');

        if (this.state.active == true) {
            if (mobileStickyHeader !== null) {
                mobileStickyHeader.style.display = 'none';
            }
            disableBodyScroll(shareModal);
        } else {
            if (mobileStickyHeader !== null) {
                mobileStickyHeader.style.display = '';
            }
            enableBodyScroll(shareModal);
        }
    }

    closeModal(e) {
        // only close modal if parent component is clicked (not children)
        if (e.target !== e.currentTarget) {
            return
        }
        this.setState({ active: false }, function() {
            // unlock scroll on body  
            this.lockScroll()
        })
    }
    
    toggleModal() {
        const currentState = this.state.active;

        this.setState({ active: !currentState }, function() {
            // toggle scroll on body  
            this.lockScroll()
        })
    }

    componentWillUnmount() {
        clearAllBodyScrollLocks();
    }

    renderSocialLinks = () => {

        const { url, title} = this.props;

        let emailSubject = encodeURIComponent(`Paul Conrad Architects: ${title}`)
        let emailBody = encodeURIComponent(`Paul Conrad Architects: ${title}\n\n${url}`)
        
        const socialLinks = [
            { 
                'title': 'Share via Email',
                'link': `mailto:?subject=${emailSubject}&body=${emailBody}`,
                'colour': '#595850',
                'target': '_self'
            },
            { 
                'title': 'Share on Facebook',
                'link': `https://www.facebook.com/sharer.php?u=${url}`,
                'colour': '#4267b2',
                'target': '_blank'
            },
            { 
                'title': 'Share on Twitter',
                'link': `https://twitter.com/intent/tweet?url=${url}`,
                'colour': '#1da1f2',
                'target': '_blank'
            },
            { 
                'title': 'Share on LinkedIn',
                'link': `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
                'colour': '#0077B5',
                'target': '_blank'
            }
        ]
        

        const links = socialLinks.map((social, i) => {
            return (
                <SocialLink
                    key={i}
                    href={social.link}
                    target={social.target}
                    colour={social.colour}
                >
                   {social.title}
                </SocialLink>
            ) 
        })
        return (
            <SocialLinks>{links}</SocialLinks>
        )     
    }

    renderShareModal = () => {
        return (
            <ShareModal
                id={'share-modal'}
                onClick={(e)=>this.closeModal(e)}
            >
                <Top>
                    <Title>Share this page</Title>
                    <Close 
                        onClick={()=>this.toggleModal()}
                    />
                </Top>
                
                {this.renderSocialLinks()}
            </ShareModal>
        )
    }
	
	render() {

		return (
			<React.Fragment>
                {/* Background Overlay (all devices) */}
                <VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
                    {this.state.active ? <Overlay onClick={() => this.toggleModal()}/> : undefined}
                </VelocityTransitionGroup>
			
                <Button 
                    onClick={()=>this.toggleModal()}
                >
                    Share
                </Button>

                {/* Desktop Share Modal */}
                <VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
                    { this.state.active && !width.tablet() ? this.renderShareModal() : undefined }
                </VelocityTransitionGroup>


                {/* Mobile Share Modal (tablet and below) */}
                <VelocityTransitionGroup enter={{animation: { translateY: 0}, duration: '300'}} leave={{animation: {translateY: '100%'}, duration: '300'}}>
                    { this.state.active && width.tablet() ? this.renderShareModal() : undefined }
                </VelocityTransitionGroup>

                {/* Background Overlay (all devices) */}
                <VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
                    {this.state.active ? <Overlay onClick={() => this.toggleModal()}/> : undefined}
                </VelocityTransitionGroup>

			</React.Fragment>
		)
	}
}

const Button = styled.div`
	height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: auto;
	font-family: 'Scto';
	font-size: 16px;
    line-height: 1;
    background-color: rgba(235, 232, 228, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	transition: background-color 0.25s ease;
    cursor: pointer;

	&:hover {
        background-color: rgba(235, 232, 228, 1);
	}

    ${media.laptop`
        height: 37px;
        font-size: 12px;
	`}
`


const Top = styled.div``
const Title = styled.div``
const Close = styled.div``
const Container = styled.div``
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(217, 217, 217, 0.5);
`
const ShareModal = styled.div`
	z-index: 999;
    position: fixed;
    bottom: 50vh;
    left: 50%;
    transform: translate(-50%,50%);
    width: 400px;
    padding: 40px;
    box-sizing: border-box;
    background: white;

    ${media.laptop`
        width: 340px;
        padding: 30px;
    `}

    ${media.tablet`
        bottom: 0;
        left: 0;
        transform: none;
        width: 100%;
        padding: 30px 60px 60px;
    `}

    ${media.phone`
        width: 100%;
        padding: 28px 40px 40px;
        padding-bottom: calc(40px + env(safe-area-inset-bottom));
    `}

    ${Top} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        ${media.tablet`
            justify-content: center;
        `}
    }

    ${Title} {
        ${paragraph};
        text-indent: 0!important;
    }

    ${Close} {
		width: 18px;
		height: 18px;
		background-image: url(${close});
        ${bgIcon}
		${hoverState}
		cursor: pointer;

        ${media.tablet`
            display: none;
        `}
    }
`


const SocialLinks = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;

    ${media.laptop`
        margin-top: 28px;
    `}

    ${media.tablet`
        flex-flow: row wrap;
    `}

    ${media.phone`
        flex-flow: column nowrap;
        margin-top: 32px;
    `}
`
const SocialLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50px;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 16px;
    line-height: 16px;
    color: white;
    ${hoverState};
    cursor: pointer;

    &:not(:first-child) {
        margin-top: 10px;

        ${media.tablet`
            margin-top: 0;
        `}
    }

    ${media.laptop`
        height: 47px;
        font-size: 12px;
        line-height: 12px;
    `}

    ${media.tablet`
        width: auto;
        flex: 0 0 calc(50% - 5px);

        &:nth-child(odd) {
            margin-right: 5px;
            ${media.phone`
                margin-right: 0;
            `}
        }

        &:nth-child(even) {
            margin-left: 5px;
            ${media.phone`
                margin-left: 0;
            `}
        }

        &:nth-child(n+3) {
            margin-top: 10px;
        }
    `}

    ${media.phone`
        flex: none;
        width: 100%;
        margin: 0;

        &:not(:first-child) {
            margin-top: 10px;
        }
    `}

	${props => {
		if (props.colour) return css`
            background-color: ${props.colour};
		`
	}}
`




export default Share


// WEBPACK FOOTER //
// ./src/components/Share/Share.js